import Head from "next/head";
import { loadStandardContent } from "@/utils/api";
import Layout from "@/components/layout";
import QuizPromo from "@/components/quiz-promo";

const people = [
  {
    name: "Zoe",
    role: "Head Of Center",
    imageUrl: "/team/zoe.png",
    bio: "Leading Excellence in Training, Innovation, and Growth",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Cham",
    role: "Nurse Practitioner",
    imageUrl: "/team/cham.png",
    bio: "Blending clinical expertise with compassionate aesthetic care",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Kelsey",
    role: "Beauty, Aesthetics Tutor & Assessor",
    imageUrl: "/team/kelsey.png",
    bio: "Inspiring beauty and aesthetics professionals with quality education",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Grace",
    role: "Permanent Makeup Tutor",
    imageUrl: "/team/grace.png",
    bio: "Mastering the art of permanent beauty, one student at a time",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Kara",
    role: "Aesthetics Tutor",
    imageUrl: "/team/kara.png",
    bio: "Providing expert tuition in aesthetics",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Samia",
    role: "Permanent Makeup & Aesthetics Tutor",
    imageUrl: "/team/samia.png",
    bio: "Shaping future experts with precision and passion in pmu and aesthetics",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Charlotte",
    role: "Beauty, Aesthetics Tutor & Assessor",
    imageUrl: "/team/charlotte.png",
    bio: "Empowering beauty professionals with top-tier training and quality assurance",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Jo",
    role: "IQA",
    imageUrl: "/team/jo.png",
    bio: "Ensuring quality and excellence in every assessment",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Sophie",
    role: "Enrolment, Administration & Admissions Officer",
    imageUrl: "/team/sophie.png",
    bio: "Streamlining your journey from enrolment to graduation",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Shannon",
    role: "Enrolment, Administration & Admissions Officer",
    imageUrl: "/team/shannon.png",
    bio: "Streamlining your journey from enrolment to graduation",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Ruby",
    role: "Models & Administration Officer",
    imageUrl: "/team/ruby.png",
    bio: "Your go-to coorindator for all things model related",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Jessica",
    role: "Models & Administration Officer",
    imageUrl: "/team/jessica.png",
    bio: "Your go-to coorindator for all things model related",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Divika",
    role: "Student Support Officer",
    imageUrl: "/team/divika.png",
    bio: "Your go-to guide for all things student support and success",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  //   {
  //     name: "Denise",
  //     role: "College Coordinator",
  //     imageUrl: "/team/denise.png",
  //     bio: "Experienced aesthetic nurse, clinic owner and trainer.",
  //     ig: "https://www.instagram.com/charmelle_injects",
  //   },
  {
    name: "Shaun",
    role: "Digital Platforms & Marketing Manager",
    imageUrl: "/team/shaun.png",
    bio: "Driving digital innovation and marketing brilliance across platforms",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Harry",
    role: "Full Stack Web Developer",
    imageUrl: "/team/harry.png",
    bio: "Building seamless digital experiences from the ground up",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  {
    name: "Danual",
    role: "Video & Marketing",
    imageUrl: "/team/danual.png",
    bio: "Crafting visual stories and marketing magic, one frame at a time",
    ig: "https://www.instagram.com/charmelle_injects",
  },
  //   {
  //     name: "James",
  //     role: "Full Stack Web Developer",
  //     imageUrl: "/team/james.png",
  //     bio: "Experienced aesthetic nurse, clinic owner and trainer.",
  //     ig: "https://www.instagram.com/charmelle_injects",
  //   },
];

export default function Team(props) {
  return (
    <main>
      <Head>
        <title>
          Meet Our Expert Educators at Cosmetic College: Leaders in Beauty,
          Aesthetics, and Permanent Makeup Training
        </title>
        <meta
          name="description"
          content="Discover the dedicated educators at Cosmetic College. Our team of experts in beauty, aesthetics, and permanent makeup are committed to providing top-tier training and support. Meet the faces driving excellence in your educational journey, ensuring you receive the best in hands-on experience and theoretical knowledge to excel in the industry."
        />
      </Head>
      <Layout siteData={props.siteData}>
        <div className="bg-white py-24 md:py-32 lg:py-40">
          <div className="mx-auto grid max-w-7xl grid-cols-1 gap-x-12 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Our team
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We are a dynamic group of individuals who are passionate about
                what we do and dedicated to delivering the best results for our
                students to grow their careers.
              </p>
            </div>
            <ul
              role="list"
              className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-8 xl:col-span-2"
            >
              {people.map((person) => (
                <li key={person.name} className="grid grid-cols-3 gap-6">
                  <div className="col-span-3 px-12 sm:px-0 sm:col-span-1 text-center">
                    <img
                      className="aspect-1 rounded-full object-cover w-full"
                      src={person.imageUrl}
                      alt=""
                    />
                  </div>
                  <div className="col-span-3 sm:col-span-2 text-center sm:text-left">
                    <h3 className="text-lg font-bold leading-8 text-gray-900">
                      {person.name}
                    </h3>
                    <p className="text-base font-semibold leading-7 text-gray-600">
                      {person.role}
                    </p>
                    <p className="mt-4 text-base leading-7 text-gray-600">
                      {person.bio}
                    </p>
                    {/* <ul role="list" className="mt-6 flex gap-x-6">
                    {person.ig ? (
                      <li>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={person.ig}
                          className="text-gray-400 hover:text-gray-500"
                        >
                          <span className="sr-only">X</span>
                          <svg
                            aria-hidden="true"
                            x="0px"
                            y="0px"
                            className="h-5 w-5"
                            viewBox="0 0 50 50"
                          >
                            <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                          </svg>
                        </a>
                      </li>
                    ) : null}
                  </ul> */}
                  </div>
                </li>
              ))}
            </ul>
          </div>
          {/* <div className="mt-32 mx-auto grid max-w-7xl grid-cols-1 gap-x-12 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Our partners
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We partner with quality providers to ensure our students receive
                first class training and support.
              </p>
            </div>
            <ul
              role="list"
              className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:gap-x-8 xl:col-span-2"
            >
              {partners.map((person) => (
                <li key={person.name} className="grid grid-cols-1 gap-6">
                  <div className="col-span-3 px-12 sm:px-0 text-center">
                    <img
                      className="object-cover w-full"
                      src={person.imageUrl}
                      alt=""
                    />
                  </div>
                  <div className="col-span-3 sm:col-span-2 text-center sm:text-left">
                    <h3 className="text-lg font-bold leading-8 text-gray-900">
                      {person.name}
                    </h3>
                    <p className="text-base font-semibold leading-7 text-gray-600">
                      {person.role}
                    </p>
                    <p className="mt-4 text-base leading-7 text-gray-600">
                      {person.bio}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div> */}
        </div>
        <div className="bg-white mx-auto max-w-7xl w-full px-4 lg:px-8">
          <QuizPromo variant="banner" />
        </div>
      </Layout>
    </main>
  );
}

export async function getStaticProps({ params, preview = false }) {
  const contentful = require("contentful");
  const client = contentful.createClient({
    space: process.env.NEXT_CONTENTFUL_SPACE || "",
    accessToken: process.env.NEXT_CONTENTFUL_KEY || "",
  });

  const entry = await client.getEntry("5QAuKRxPhoABYixnFUIJqv", { include: 3 });
  const siteData = await loadStandardContent();
  return {
    props: {
      entry: entry,
      includes: entry.includes || {},
      siteData,
    },
  };
}
